import { LevelType } from 'data/types';
import { sortLevelsByVerticalPosition } from 'utils/structure-basics';

export function getLevelsPhysicallyAbove(
  structure: LevelType[],
  levelUniqueId: string
): LevelType[] {
  const ordered = sortLevelsByVerticalPosition(structure);
  const index = ordered.findIndex((level) => level.uniqueId === levelUniqueId);
  if (index === -1) {
    return [];
  }
  return ordered.slice(index + 1);
}

export function getImmediateLevelAbove(
  structure: LevelType[],
  levelUniqueId: string
): LevelType | undefined {
  return getLevelsPhysicallyAbove(structure, levelUniqueId)[0];
}

export function getImmediateLevelBelow(
  structure: LevelType[],
  levelUniqueId: string
): LevelType | undefined {
  const ordered = sortLevelsByVerticalPosition(structure);
  const index = ordered.findIndex((level) => level.uniqueId === levelUniqueId);
  if (index <= 0) {
    return undefined;
  }
  return ordered[index - 1];
}
